import { GetCustomerReferralDetailsQuery } from "@/api/hasura/generated/graphql"
import { getReferralCodeFromCustomerNumber } from "@/helpers/referralHelper"
import { Address } from "@/models/address/address"
import { ReferralCodeDetail } from "./referralCodeDetails"

export const parseReferralCodeDetail = (
  data: GetCustomerReferralDetailsQuery["customer"][number],
) => {
  const address =
    data.billing_accounts[0].billing_account_contacts[0]?.contact.address

  return new ReferralCodeDetail(
    getReferralCodeFromCustomerNumber(data.number),
    !data.customer_setting.referrals_enabled,
    {
      customerNumber: data.number,
      firstName: data.first_name,
      lastName: data.last_name,
      userId: data.customer_user_rels[0]?.user?.id,
      email: data.customer_user_rels[0]?.user?.email ?? "",
      customerSettingsId: data.customer_setting.id,
      address: address
        ? new Address(
            address.country_code || "",
            address.postcode || "",
            address.address1 || "",
            address.address2 || "",
            address.address3 || "",
          )
        : undefined,
    },
    data.customer_referrals.map((referral) => ({
      userId: referral.referred.customer_user_rels[0]?.user_id,
      firstName: referral.referred.first_name,
      lastName: referral.referred.last_name,
      credit: referral.credit,
      status: referral.status,
    })),
  )
}
